import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getKyc, upload } from 'tg-core-redux/lib/modules/kyc/action';
import marked from 'marked';
import { VerifyAccordionWidget, Translate } from 'tg-core-components';
import OffCanvasLayout from '@components/OffCanvasLayout';
import withRouteData, { Loader } from '@utils/withRouteData';
import { loadContents } from '@actions/content';

const toKebab = (str = '') =>
  String(str)
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/\s+/g, '-')
    .toLowerCase();

const parseTypeFromHash = hash => {
  const h = (hash || '').replace(/^#/, '');
  const m = h.match(/^dashboard\/verify\/([^/]+)$/i);
  if (!m) return null;
  return m[1]?.toLowerCase() || null;
};

@withRouteData
@connect(
  state => ({
    sessionId: state.player.sessionId,
    pages: state.content.pages.data,
    sets: state.content.sets.data,
    kyc: state.kyc.data,
  }),
  {
    getKyc,
    upload,
  }
)
class VerifyContainer extends Component {
  static hashRoute = true;
  static globalLoader = false;
  static dataLoader = loadContents([
    {
      name: 'page',
      urls: ['#dashboard/verify'],
    },
    {
      name: 'set',
      identifiers: ['kyc-types', 'verify-profile-instruction'],
    },
  ]);

  state = {
    routeType:
      typeof window !== 'undefined'
        ? parseTypeFromHash(window.location.hash)
        : null,
  };

  componentDidMount() {
    const { getKyc, sessionId } = this.props;

    getKyc(sessionId);

    this._onHashChange = () =>
      this.setState({ routeType: parseTypeFromHash(window.location.hash) });
    window.addEventListener('hashchange', this._onHashChange, false);
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this._onHashChange, false);
  }

  setHashAndState = typeKey => {
    this.setState({ routeType: typeKey });
    const base = `${window.location.pathname}${window.location.search}`;
    const target = `${base}#dashboard/verify/${typeKey}`;
    window.history.replaceState(null, '', target);
  };

  onSubmit = data => {
    const { sessionId } = this.props;
    const reader = new FileReader();

    reader.onload = e => {
      this.props
        .upload(sessionId, {
          Type: data.Type,
          Image: e.target.result.split(',')[1],
        })
        .then(() => data.doneCallback && data.doneCallback());
    };

    reader.readAsDataURL(data.Image);
  };

  render() {
    const { pages, sets, kyc } = this.props;
    const { routeType } = this.state;

    const page = pages?.find(p => p.url === '#dashboard/verify');
    const types = sets?.find(s => s.identifier === 'kyc-types');

    const items = types?.items.map(type => {
      const rawKey = type?.config?.Type || '';
      const typeKey = toKebab(rawKey);
      const isExpanded = routeType === typeKey;

      return {
        ...type,
        expanded: isExpanded,
        header: (
          <div
            className="title-text"
            role="button"
            tabIndex={0}
            onClick={() => this.setHashAndState(typeKey)}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ')
                this.setHashAndState(typeKey);
            }}>
            <Translate id={`label.${type.identifier}`} />
          </div>
        ),
        content: marked(type.content || ''),
      };
    });

    return (
      <OffCanvasLayout className="VerifyContainer" backUrl="#dashboard">
        <Loader isLoading={!page}>
          {page?.content && (
            <header
              dangerouslySetInnerHTML={{ __html: marked(page.content) }}
            />
          )}

          <VerifyAccordionWidget
            onSubmit={this.onSubmit}
            items={items}
            data={kyc}
          />
        </Loader>
      </OffCanvasLayout>
    );
  }
}

export default VerifyContainer;
